<template>
  <div class="subscriptionModal">
    <el-form ref="form" :model="editMembershipSubscription" :rules="membershipSubscriptionRules" label-width="140px">
      <el-form-item label="店舗" prop="clinic" :error="validationErrors.clinic" v-if="permission.can('write_all', 'membershipsubscription')">
        <v-select
            :disabled="membershipSubscriptionIsEdit"
            id="currentClinicId"
            v-model="editMembershipSubscription.clinic"
            label="clinic_name"
            item-text="clinic_name"
            item-value="id"
            :options="currentClinics"
            placeholder="店舗選択"
            filterable
            required
            @input="onChangeClinic($event)">
          <template #no-options="{ search, searching, loading }">
            データはありません。
          </template>
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes" class="el-select__caret el-input__icon el-icon-arrow-down"></span>
          </template>
        </v-select>
      </el-form-item>
      <el-form-item label="名前" prop="clinic_customer_note" :error="validationErrors.clinic_customer_note_id" >
        <el-input v-if="membershipSubscriptionIsEdit" :disabled="true" :value="editMembershipSubscription.clinic_customer_note.full_name"/>
        <v-select
          v-else
          id="customerNoteId"
          v-model="editMembershipSubscription.clinic_customer_note"
          label="all_name_with_uid"
          item-text="all_name_with_uid"
          item-value="id"
          @search="filterCustomers($event)"
          :options="clinicCustomerNotes"
          :filterable="false"
          placeholder="名前を入力し検索"
          required
          @input="onChangeCustomerNote"
          >
          <template #no-options="{ search, searching, loading }">
            データはありません。
          </template>
          <template #open-indicator="{ attributes }">
            <span v-bind="attributes" class="el-select__caret el-input__icon el-icon-arrow-down"></span>
          </template>
        </v-select>
      </el-form-item>
      <el-form-item label="会員番号" prop="member_code" :error="validationErrors.member_code" >
        <el-input 
          v-model="editMembershipSubscription.member_code" 
          placeholder="会員番号" 
          required 
          type="number" 
          min="1"
          :disabled="isDisabled()">
        </el-input>
      </el-form-item>
      <el-form-item label="会員プラン" prop="subscription_package.id" :error="validationErrors.subscription_package">
        <el-input v-if="membershipSubscriptionIsEdit" :disabled="true" :value="editMembershipSubscription.subscription_package.name"/>
        <el-select
          v-else
          v-model="editMembershipSubscription.subscription_package.id" 
          filterable placeholder="会員プラン" required 
          @change="onChangeSubscriptionPackage">
          <el-option
              v-for="subscriptionPackage in modalSubscriptionPackages"
              :key="subscriptionPackage.id"
              :label="subscriptionPackage.name"
              :value="subscriptionPackage.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="会員ステータス" prop="contract_status">
        <el-select 
          v-model="editMembershipSubscription.contract_status" 
          filterable 
          placeholder="会員ステータス" 
          required
          :disabled="isDisabled()">
          <el-option
              v-for="subscriptionPackage in subscriptionContractStatuses"
              :key="subscriptionPackage.key"
              :label="subscriptionPackage.value"
              :value="subscriptionPackage.key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="購入日" prop="purchase_date" :error="validationErrors.purchase_date">
        <el-date-picker
          v-model="editMembershipSubscription.purchase_date"
          type="date"
          placeholder="日を選ぶ"
          :picker-options="{ firstDayOfWeek: startWeekday }"
          :value-format="membershipSubscriptionIsEdit ? undefined : 'yyyy-MM-dd'"
          :disabled="isDisabled()">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="ポイント数" prop="total_point" :error="validationErrors.total_point">
        <el-input-number
            :disabled="true"
            controls-position="right" :min="0"
            prefix-icon="el-icon-search"
            v-model="editMembershipSubscription.total_point" placeholder="ポイント数" required/>
      </el-form-item>
      <div class="text-center">
        <el-button type="info" class="mr-3 btn-clinic-coupon" @click="SET_IS_SUBSCRIPTION_VISIBLE(false)">閉じる</el-button>
        <el-button type="primary" class="btn-clinic-coupon" 
            @click="submitForm('form')" 
            :hidden="isDisabled()">
          {{getBtnTitle}}
        </el-button>
        <el-popconfirm v-if="membershipSubscriptionIsEdit"
            title="回数券を削除します。よろしいでしょうか？"
            confirm-button-text="登録"
            cancel-button-text="閉じる"
            @confirm="onConfirmDelete(editMembershipSubscription)"
        >
<!--          <el-button-->
<!--              class="btn-clinic-coupon"-->
<!--              slot="reference"-->
<!--              type="danger"-->
<!--          >-->
<!--            削除-->
<!--          </el-button>-->
        </el-popconfirm>
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import permissionService from "../../services/permission_service";

export default {
  data() {
    return {
      permission: permissionService,
      debounceTimer: null,
    }
  },
  computed: {
    ...mapGetters(['startWeekday', 'editMembershipSubscription', 'membershipSubscriptionRules', 'total', 'clinicCustomerNotes', 'membershipSubscriptionIsEdit','modalSubscriptionPackages', 'subscriptionContractStatuses', 'validationErrors', 'currentClinics', 'currentClinic']),
    getBtnTitle() {
      return '登録'
    }
  },
  methods: {
    ...mapActions('clinic_customer_note', ['fetchClinicCustomerNotes']),
    ...mapMutations('membership_subscription', ['SET_IS_SUBSCRIPTION_VISIBLE']),
    ...mapActions('membership_subscription', ['createMembershipSubscription', 'updateMembershipSubscription', 'removeMembershipSubscription']),
    ...mapActions('subscription_package', ['fetchModalSubscriptionPackages']),
    isDisabled() {
      if (!this.membershipSubscriptionIsEdit)
        return false;

      let not_write_all = this.editMembershipSubscription.clinic.id != this.currentClinic.id && !this.permission.can('write_all', 'membershipsubscription');
      return !this.permission.can('write', 'membershipsubscription') || not_write_all;
    },
    onConfirmDelete(val){
      if(this.membershipSubscriptionIsEdit) {
        this.removeMembershipSubscription(val.id)
      }
    },
    filterCustomers(query) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer =  setTimeout(async () => {
        await this.fetchClinicCustomerNotes({clinic_id: this.editMembershipSubscription.clinic.id, query: query});
      }, 300);
    },
    submitForm(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          clearTimeout(this.debounceTimer);
          this.debounceTimer = setTimeout(async () => {
            if (this.membershipSubscriptionIsEdit) {
             await this.updateMembershipSubscription(this.editMembershipSubscription)
            } else {
             await this.createMembershipSubscription(this.editMembershipSubscription)
            }
          }, 300)
        } else {
          return false
        }
      })
    },
    onChangeSubscriptionPackage(event) {
      let itemSelect =  this.modalSubscriptionPackages.find(item => item.id === event)
      this.editMembershipSubscription.total_point = itemSelect.point
    },
    onChangeCustomerNote(event) {
      if (event && event.member_code) {
        this.editMembershipSubscription.member_code = event.member_code
      } else {
        this.editMembershipSubscription.member_code = null
      }
    },
    async onChangeClinic(event) {
      await this.fetchClinicCustomerNotes({ clinic_id: event.id })
      this.fetchModalSubscriptionPackages({ clinic_id: event.id })
      this.editMembershipSubscription.clinic_customer_note = []
      this.editMembershipSubscription.subscription_package = []
    },
  }
}
</script>
<style scoped>
.btn-clinic-coupon {
  width: 85px;
}
</style>
